import '@calibrant-nav';
import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { Router, RouterOutlet } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { AlertComponent, LoaderComponent, TreeComponent } from '@components';
import {
  CookieService,
  GenericOldService,
  LoaderService,
  NavbarService,
  SidenavService,
  TreeService,
} from 'src/app/services';

@Component({
  imports: [
    AlertComponent,
    MatSidenavContainer,
    MatSidenav,
    MatIconButton,
    MatIcon,
    TreeComponent,
    LoaderComponent,
    RouterOutlet,
    TranslatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'monitor-ui-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  disabledInput = true;
  @ViewChild('searchInput') input: ElementRef;
  mode: 'over' | 'push' | 'side' = 'side';
  navUrl: string;
  @ViewChild('sidenav') sidenav: MatSidenav;
  private _onDestroy = new Subject<void>();

  constructor(
    protected navbarService: NavbarService,
    private translateService: TranslateService,
    protected sidenavService: SidenavService,
    private treeService: TreeService,
    public loaderService: LoaderService,
    public cookieService: CookieService,
    private router: Router,
    private resourceService: GenericOldService<string>,
    @Inject(DOCUMENT) private _document: Document,
  ) {
    this.loaderService.regexEndpoints = ['ess-parameters', 'permission', 'run'];
    this.getNavUrl();
  }

  getMode(): 'over' | 'push' | 'side' {
    this.mode = this.isLargeScreen() ? 'side' : 'over';
    return this.mode;
  }

  isLargeScreen(): boolean {
    const width = window.innerWidth || this._document.documentElement.clientWidth || this._document.body.clientWidth;
    return width > 1280;
  }

  ngAfterViewInit(): void {
    const logo = this._document.querySelector('.logo') as HTMLElement;
    if (logo) {
      logo.style.cursor = 'pointer';
      logo.addEventListener('click', async () => {
        await this.router.navigateByUrl('/');
      });
    }
    if (this.sidenav) {
      this.sidenavService.setSidenav(this.sidenav);
      this.sidenavService.open();
    } else {
      throw new Error('No sidenav exists');
    }
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
  }

  ngOnInit(): void {
    const locale = this.cookieService.getI18NLocale() || 'en-us';
    const brand = this.cookieService.getI18NBrand() || 'calibrant';
    this.translateService.setDefaultLang(`${locale}.${brand.toUpperCase()}`);
    this.translateService.use(`${locale}.${brand.toUpperCase()}`);
    this.treeService.enableFilterInput$
      .pipe(takeUntil(this._onDestroy))
      .subscribe(enable => (this.disabledInput = !enable));
  }

  sidenavContentStyle(): object {
    const style = window.getComputedStyle(this._document.body);
    const dockWidth = +style.getPropertyValue('--sidenav-dock-width').match(/\d+/)[0];
    const fullWidthWidth = this._document.querySelector('mat-sidenav').clientWidth;
    const matContentMargin = this.sidenav?.opened ? `${fullWidthWidth}px` : `${dockWidth + 5}px`;
    return {
      'padding-left': this.mode !== 'over' ? `${matContentMargin} !important` : `${dockWidth + 5}px !important`,
    };
  }

  private getNavUrl(): void {
    this.resourceService.get('links/nav').subscribe(navUrl => (this.navUrl = navUrl));
  }
}
